import categoryAPI from '@/api/categories'

export const setCategories = ({ dispatch }, categoryId) => {
  return new Promise((resolve, reject) => {
    dispatch('getCategoryParent', categoryId)
    dispatch('getCategoryChild', categoryId)
    dispatch('getCategory', categoryId).then(() => {
      resolve()
    })
  })
}

export const setCategoryTranslation = ({dispatch}) => {
  return new Promise((resolve, reject) => {
    dispatch('getCategoryTranlation').then(() => {
      resolve()
    })
  })
}

export const getCategoryTranlation = ({commit}) => {
  return new Promise((resolve, reject) => {
    categoryAPI.getCategoryTranlation(translation => {
      commit('setCategoryTranslation', translation)
      resolve()
    })
  })
}

export const getCategory = ({ commit, dispatch }, categoryId) => {
  return new Promise((resolve, reject) => {
    categoryAPI.getCategoryById(category => {
      commit('setCategory', category)
      resolve()
    }, categoryId)
  })
}

export const getCategoryParent = ({ commit }, categoryId) => {
  categoryAPI.getCategoryParent(categoryParents => {
    commit('setCategoryParent', categoryParents)
  }, categoryId)
}

export const getCategoryChild = ({ commit }, categoryId) => {
  categoryAPI.getCategoryChild(categoryChilds => {
    commit('setCategoryChild', categoryChilds)
    commit('setAvailableQuota', categoryChilds.data.data.available_quota)
  }, categoryId)
}

export const getCategories = () => {
  return new Promise((resolve, reject) => {
    let categories = []
    let toggleStatus = []
    let categoryLineage = []
    let translations = []

    categoryAPI.getCategories(results => {
      categories.push({
        'level': results.data.data.catalog[0].level,
        'id': results.data.data.catalog[0].id,
        'name': results.data.data.catalog[0].name,
        'status': true,
        'child': results.data.data.catalog[0].child
      }) // status at Home for update toggle
      toggleStatus[0] = true
      categoryLineage[0] = results.data.data.catalog[0].name
      translations = results.data.data.translations

      resolve({
        categories,
        toggleStatus,
        categoryLineage,
        translations
      })
    })
  })
}

export const getVelaeasySectionsCategoryAPI = ({ commit }, categoryId) => {
  return new Promise((resolve, reject) => {
    categoryAPI.getVelaeasySections(result => {
      resolve(result.data.data)
    }, categoryId)
  })
}

export const checkCategoryStaticUrlAPI = ({ commit }, categoryStaticurl) => {
  return new Promise((resolve, reject) => {
    categoryAPI.checkCategoryStaticUrl(result => {
      resolve(result.data.data)
    }, categoryStaticurl)
  })
}

export const getCategorySortingOptions = ({ commit }, categoryId) => {
  return new Promise((resolve, reject) => {
    categoryAPI.getCategorySortingOptions(categoryId, results => {
      if (results.data.status === 'success') {
        resolve(results.data.data)
      } else {
        reject()
      }
    })
  })
}

export const getCategoriesSortList = ({ commit }, categoryId) => {
  return new Promise((resolve, reject) => {
    categoryAPI.getCategoriesSortList(categoryId, categoriesList => {
      commit('setCategoriesSortList', categoriesList)
      resolve(categoriesList)
    })
  })
}

export const getCategorySortListById = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    categoryAPI.getCategorySortListById(params, result => {
      commit('setCategoriesSortList', result)
      resolve(result)
    })
  })
}

export const updateCategoriesSortList = ({commit}, params) => {
  return new Promise((resolve, reject) => {
    categoryAPI.updateCategoriesSortList(params, result => {
      resolve(result)
    })
  })
}

export const updateCategoriesSorting = ({commit}, params) => {
  return new Promise((resolve, reject) => {
    categoryAPI.updateCategoriesSorting(params, result => {
      commit('setSortingEditKey', result)
      resolve(result)
    })
  })
}

export const getDefaultSortOptionsSetting = ({commit}) => {
  return new Promise((resolve, reject) => {
    categoryAPI.getDefaultSortOptionsSetting(result => {
      resolve(result)
    })
  })
}

export const insertDefaultCategorySorting = ({commit}, params) => {
  return new Promise((resolve, reject) => {
    categoryAPI.insertDefaultCategorySorting(params, result => {
      resolve(result)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/categories/actions.js